(function () {
  document
    .querySelector('.wp-block-cb-carousel')
    ?.addEventListener(
      'beforeChange',
      function (event, slick, currentSlide, nextSlide) {
        const slide = slick.$slides[currentSlide].querySelector(
          '.is-provider-youtube'
        );
        if (slide) {
          const slideIframe = slide.querySelector('iframe');
          slideIframe?.contentWindow.postMessage(
            '{"event":"command","func":"stopVideo","args":""}',
            '*'
          );
        }
      }
    );
})();
